export const drawerWidth = 300;

export const NO_IMAGE_AVAILABLE_SRC = "/no_image_available.png";

export const oneKBsize = 1000;
export const oneMBsize = Math.pow(oneKBsize, 2);
export const oneGBsize = Math.pow(oneKBsize, 3);

export const MAX_VIDEO_SIZE = oneGBsize * 10; // 10 gb
export const MAX_IMAGE_SIZE = oneMBsize * 100; // 100 mb
export const MAX_PREVIEW_SIZE = oneMBsize * 5; // 5 mb
export const MAX_SUBTITLE_SIZE = oneMBsize * 25; // 25 mb

export const buttonStyle = {
  borderRadius: 8,
  width: { xs: 1, sm: "auto" },
};

export enum ROLES {
  VIEWER = 1,
  COORDINATOR = 2,
  SYSTEM_ADMIN = 3,
}

export const Roles = [
  { id: ROLES.VIEWER, name: "Viewer", description: "" },
  { id: ROLES.COORDINATOR, name: "Coordinator", description: "" },
  { id: ROLES.SYSTEM_ADMIN, name: "System Administrator", description: "" },
];

export const axiosHeader = {
  "Content-Type": "application/x-www-form-urlencoded",
};

export const API_BASE_URL = "/api/ikm/v1"

export const isSafariBrowser = /^((?!chrome|android).)*safari/i.test(
  navigator.userAgent,
);

export const TAGS = ["All", "G2E 2023", "ICE 2024", "Marketing"];

export const shareId = window.location.pathname.split("/").slice(-1)[0];

export const notFound = "Not found";

export enum FIELD {
  MARKET = "market",
  COUNTRY = "country",
  CATEGORY = "segment",
  CATEGORY_OLD = "category",

  SOFTWARE = "software",
  SOFTWARE_PLATFORM = "software_platform",
  SOFTWARE_VERSION = "software_version",
  RTP = "rtp",
  OS = "operating_system",
  PRODUCT_STATUS = "product_status",

  HARDWARE_PLATFORM = "hardware_platform",
  CABINET = "cabinet",
  VARIANT = "game_variant",
  GAME_SELECTOR = "game_selector",
  EEPROM = "license_eeprom",
  CONFIG = "config",
  GAMING_BOARD = "gaming_authority",
  GAMING_AUTHORITY_CERTIFICATE = "gaming_authority_certificate",

  SUBMISSION_STATUS = "status",
  TEST_LAB = "test_lab",
  TEST_LAB_REPORT = "report",
  SUBMISSION_CODE = "license_code",
  REPORT_DATE = "report_date",
  VALID_UNTIL = "valid_until",
  EXPECTED_DATE = "expected_date",
  SUBMISSION_DATE = "submission_date",
  GAMING_AUTHORITY_CERTIFICATE_DATE = "certificate_date",

  COMMENT = "comment",
  INTERNAL_COMMENT = "internal_comment",
  RENOID = "reno_id",

  QUERY = "query",
  GROUP_BY = "group_by",
  ORDER_BY = "order_by",
  PER_PAGE = "per_page",
  PAGE = "page",
  DIRECTION = "direction",
  ORDER = "order",
  FIELD = "field",
}
